import {BASE_URL} from "../../config/network";
import {resolveWhiteLabelSubsidiaryId} from "../../config/subsidiaryId";

const getResponseJson = async (response) => {
    try {
        return await response.json();
    } catch (_error) {
        return null;
    }
};

const createDocumentCaptureSessionAPI = async ({
    subsidiaryId,
    documents = ["drivers_license"],
    selfie = true,
    reference = "",
    requestedBy = "newway-website",
    ttlMinutes = 60,
    qrSize = 340,
    locale = "nl",
}) => {
    const requestSubsidiaryId = resolveWhiteLabelSubsidiaryId(subsidiaryId);
    const URL = `${BASE_URL}/${requestSubsidiaryId}/public/document-capture/session`;
    const METHOD = "POST";
    const HEADERS = {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
    };

    const body = new URLSearchParams();
    documents.forEach((documentType) => body.append("documents[]", documentType));
    body.set("selfie", selfie ? "true" : "false");
    body.set("requested_by", requestedBy);
    body.set("ttl_minutes", String(ttlMinutes));
    body.set("qr_size", String(qrSize));
    if (reference) body.set("reference", reference);
    if (locale) body.set("locale", locale);

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS,
        body: body.toString(),
    });
    const responseJson = await getResponseJson(response);

    if (!response.ok) {
        const errorMessage = responseJson?.error?.message || responseJson?.message || `HTTP error: ${response.status}`;
        throw new Error(errorMessage);
    }

    return responseJson;
};

export {createDocumentCaptureSessionAPI};
